export function getFirstErrorMessage(errors) {
  for (const key in errors) {
    const value = errors[key];

    if (!value) continue;

    // Si es string → ya es un error
    if (typeof value === "string") {
      return value;
    }

    // Si es un objeto → buscar dentro
    if (typeof value === "object") {
      for (const subKey in value) {
        if (typeof value[subKey] === "string") {
          return value[subKey];
        }
      }
    }

    // Si es array (como cartItems)
    if (Array.isArray(value) && value.length > 0) {
      return value[0]; // asumimos que es un string
    }
  }

  return null;
}